export default theme => ({
  generatingValuesText: {
    color: 'var(--jmi-blue)',
    marginRight: '24px',
    marginBottom: '8px',
  },
  circularProgress: {
    color: 'var(--jmi-blue)',
  },
});
